/* eslint-disable */
import React, { Component } from "react";
import "../../Component/Banner.css";
import moment from "moment";
import { RangeDatePicker } from "react-google-flight-datepicker";
import "react-google-flight-datepicker/dist/main.css";
import {
  getAdminPackageDetails,
  getPackageCategory,
  updateAdminPackage,
} from "../../Component/axios";

import "react-day-picker/lib/style.css";
import { clearAdminPackageCart, setPlanShuffleUpdateUrl } from "../../redux/actions/actions";
import { connect } from "react-redux";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';

class CityStuffleBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
      isOpen: false,
      dropdownVisible: false,
      //selected: "Accommodations",
      searchInput: "",
      itemsZone: [],
      error: null,
      val: "",
      value: "",
      suggestions: [],
      showResults: false,
      defaultZoneval: "Seychelles",
      addMoreLocation: [],
      checkinShow: false,
      itineraryPlan: "",
      selectedStartLocation: "",
      packageid: "",
      packageName: "",
      packageDescription: "",
      packageImage: "",
      packageOpenDate: "",
      packageCloseDate: "",
      packaeCategory: [],
      selectedEndLocation: "",
      CategoryData: "",
      packageData: "",
      UseSecondOption: false,
      cats: [
        { adultCounter: 1, childCounter: 0, roomCounter: 1, isExpanded: true },
      ],
      changeDate: [
        {
          number: "",
          startDate: "",
          endDate: "",
          indexid: "",
        },
      ],
      children: [
        {
          Id: "",
          Location: "",
          name: "",
          range: [
            {
              number: "",
              startDate: "",
              endDate: "",
              indexid: "",
            },
          ],
        },
      ],
      disableSelectOption: false,
      checkedcoming: false,
    };
  }

  componentDidMount() {
    this.props.planShuffleUpdateUrl(window.location.href);
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const defaultZoneval = urlParams.get("moreLocation");
    const checkin = urlParams.get("checkin");
    const checkout = urlParams.get("checkout");
    const guestCombination = urlParams.get("guestCombination");
    const package_id = urlParams.get("package_id");

    this.setState({ packageid: package_id });
    getAdminPackageDetails(package_id).then(
      (data) => {
        this.setState({ packageName: data?.package_data?.package_name });
        this.setState({ packageDescription: data?.package_data?.package_description });
        this.setState({ packageImage: data?.package_data?.package_image });
        this.setState({ CategoryData: data?.package_data?.package_categoryid });
        this.setState({ packageOpenDate: data?.package_data?.package_open_date });
        this.setState({ packageCloseDate: data?.package_data?.package_close_date });
        this.setState({ packageData: data });
      },
      (error) => { }
    );

    getPackageCategory().then(
      (data) => {
        this.setState({ packaeCategory: data });
      },
      (error) => { }
    );

    let querySearch = JSON.parse(guestCombination);
    this.setState({ addMoreLocation: defaultZoneval });
    this.setState({ startDate: checkin });
    this.setState({ endDate: checkout });
    this.setState({ cats: querySearch });
    const numberOfLocation = JSON.parse(defaultZoneval).length;

    let startDate = moment(checkin);
    let endDate = moment(checkout);
    let diff = endDate.diff(startDate);
    let diffDuration = moment.duration(diff);
    let TotalDays = diffDuration.days();

    let result = [];
    const startDateNew = new Date(checkin);
    const endDateNew = new Date(checkout);

    // Calculate the total number of days in the range
    const totalDays = (endDateNew - startDateNew) / (1000 * 60 * 60 * 24);

    // Divide the range into four equal parts
    let daysPerPart = Math.floor(totalDays / numberOfLocation);
    let reminder = totalDays % numberOfLocation;

    // Initialize an array to store the results
    const dividedRanges = [];

    JSON.parse(defaultZoneval).map((location, index) => {
      let numberDay = "";

      if (TotalDays % numberOfLocation == 0) {
        numberDay = TotalDays / numberOfLocation;
      } else {
        numberDay = TotalDays % numberOfLocation;
      }

      let DateMain = [];
      const partStartDate = new Date(startDateNew);
      const partEndDate = new Date(partStartDate);
      // Calculate the end date for the current part
      partEndDate.setDate(partEndDate.getDate() + daysPerPart);
      // If there's a reminder, distribute it across the parts
      if (reminder > 0) {
        partEndDate.setDate(partEndDate.getDate() + 1);
        reminder--;
      }
      // Store the calculated part in the results array
      let startDateNewData = moment(partStartDate);
      let endDateNewData = moment(partEndDate);
      let diffNewDataNew = endDateNewData.diff(startDateNewData, "days");
      DateMain.push({
        number: diffNewDataNew,
        startDate: moment(partStartDate).format("Y-MM-DD"),
        endDate: moment(partEndDate).format("Y-MM-DD"),
        indexid: index,
      });

      dividedRanges.push({
        number: diffNewDataNew,
        startDate: moment(partStartDate).format("Y-MM-DD"),
        endDate: moment(partEndDate).format("Y-MM-DD"),
        indexid: index,
      });
      // Update the start date for the next part
      startDateNew.setDate(partEndDate.getDate());

      let newData = {
        Id: location.id,
        Location: location.value,
        name: diffNewDataNew,
        range: DateMain,
      };
      result.push(newData);
    });

    this.setState({ changeDate: dividedRanges });
    this.setState({ children: result });
    const treeData = [
      {
        cat: querySearch,
        Planname: `${JSON.parse(defaultZoneval)
          .map((list) => JSON.stringify(list?.value?.label))
          .join(", ")} - (${moment(checkin).format("ddd, DD MMM Y")} - ${moment(
            checkout
          ).format("ddd, DD MMM Y")})`,
        range: [{ startDate: checkin, endDate: checkout }],
        numberOfDay: TotalDays,
        numberOfLocation: numberOfLocation,
        children: result,
      },
    ];
    this.setState({ itineraryPlan: treeData });
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.globalClickListener);
  }
  globalClickListener = (nativeEvent) => {
    this.setState(
      { dropdownVisible: false, showResults: false, checkinShow: false },
      () => {
        window.removeEventListener("click", this.globalClickListener);
      }
    );
  };
  handleDateChange = (startDate, endDate, index) => {
    let updatedData = [];
    let updatedDataNew = [];
    let valueData = [];

    JSON.parse(this.state.addMoreLocation).map((location, i) => {
      // Create a copy of the original array
      let DateMain = [];

      const indexToUpdate = this.state.changeDate.find(
        (item) => item.indexid === i
      );

      if (i == index) {
        const newStartDate = new Date(startDate);

        const newEndDate = new Date(endDate);
        let result = moment(newEndDate).diff(newStartDate, "days");

        if (i == this.state.changeDate.length - 1) {
          this.setState({ endDate: endDate });
        }

        DateMain.push({
          number: result,
          startDate: moment(startDate).format("Y-MM-DD"),
          endDate: moment(endDate).format("Y-MM-DD"),
          indexid: i,
        });
        let newData = {
          Id: location.id,
          Location: location.value,
          name: result,
          range: DateMain,
        };
        updatedDataNew.push(newData);

        this.setState((prevState) => {
          updatedData = [...prevState.changeDate]; // Create a copy of the original array
          updatedData[i].startDate = startDate; // Update the value at the specified index
          updatedData[i].endDate = endDate; // Update the value at the specified index
          updatedData[i].number = result; // Update the value at the specified index
          return { changeDate: updatedData }; // Update the state with the modified array
        });
      } else if (i == index + 1) {
        const indexToUpdatenext = this.state.changeDate.find(
          (item) => item.indexid === i
        );
        let endDateNew = moment(indexToUpdatenext.startDate)
          .add(indexToUpdatenext?.number, "day")
          .format("Y-MM-DD");
        const newStartDate = new Date(endDate);
        const newEndDate = new Date(indexToUpdatenext.endDate);

        let result = moment(newEndDate).diff(newStartDate, "days");

        DateMain.push({
          number: result,
          startDate: moment(endDate).format("Y-MM-DD"),
          endDate: moment(endDateNew).format("Y-MM-DD"),
          indexid: i,
        });
        let newData = {
          Id: location.id,
          Location: location.value,
          name: result,
          range: DateMain,
        };
        updatedDataNew.push(newData);

        this.setState((prevState) => {
          updatedData = [...prevState.changeDate]; // Create a copy of the original array
          updatedData[i].startDate = endDate; // Update the value at the specified index
          updatedData[i].endDate = endDateNew; // Update the value at the specified index
          updatedData[i].number = result; // Update the value at the specified index
          return { changeDate: updatedData }; // Update the state with the modified array
        });
      } else if (i == this.state.changeDate.length - 1) {
        const indexToUpdatedata = this.state.changeDate.find(
          (item) => item.indexid === i - 1
        );

        let endDateNew = moment(indexToUpdatedata.endDate).format("Y-MM-DD");

        const newStartDate = new Date(indexToUpdatedata.endDate);
        const newEndDate = new Date(this.state.endDate);

        let result = moment(newEndDate).diff(newStartDate, "days");

        DateMain.push({
          number: result,
          startDate: moment(endDateNew).format("Y-MM-DD"),
          endDate: moment(this.state.endDate).format("Y-MM-DD"),
          indexid: i,
        });
        let newData = {
          Id: location.id,
          Location: location.value,
          name: result,
          range: DateMain,
        };
        updatedDataNew.push(newData);

        this.setState((prevState) => {
          updatedData = [...prevState.changeDate]; // Create a copy of the original array
          updatedData[i].startDate = endDateNew; // Update the value at the specified index
          updatedData[i].endDate = this.state.endDate; // Update the value at the specified index
          updatedData[i].number = result; // Update the value at the specified index

          return { changeDate: updatedData }; // Update the state with the modified array
          // valueData = { changeDate: updatedData };
        });
      } else {
        const indexToUpdatedata = this.state.changeDate.find(
          (item) => item.indexid === i
        );
        let endDateNew = moment(indexToUpdatedata?.endDate).format("Y-MM-DD");
        let startDateNew = moment(indexToUpdatedata?.startDate).format(
          "Y-MM-DD"
        );
        const newStartDate = new Date(indexToUpdatedata?.startDate);
        const newEndDate = new Date(indexToUpdatedata?.endDate);
        let result = moment(newEndDate).diff(newStartDate, "days");

        DateMain.push({
          number: result,
          startDate: startDateNew,
          endDate: endDateNew,
          indexid: i,
        });
        let newData = {
          Id: location.id,
          Location: location.value,
          name: result,
          range: DateMain,
        };
        updatedDataNew.push(newData);

        this.setState((prevState) => {
          updatedData = [...prevState.changeDate]; // Create a copy of the original array
          updatedData[i].startDate = startDateNew; // Update the value at the specified index
          updatedData[i].endDate = endDateNew; // Update the value at the specified index
          updatedData[i].number = result; // Update the value at the specified index
          return { changeDate: updatedData }; // Update the state with the modified array
          // valueData = { changeDate: updatedData };
        });
      }
    });
    this.setState({ children: updatedDataNew });
    const treeData = [
      {
        cat: this.state.itineraryPlan[0].cat,
        Planname: this.state.itineraryPlan[0].Planname,
        range: [
          { startDate: this.state.startDate, endDate: this.state.endDate },
        ],
        numberOfDay: this.state.itineraryPlan[0].numberOfDay,
        numberOfLocation: this.state.changeDate.length,
        children: updatedDataNew,
      },
    ];

    this.setState({ itineraryPlan: treeData });
    return valueData;
  };

  handleSelectCategory = (event) => {
    this.setState({ CategoryData: event.target.value });
  };
  handlePackageChange = (event) => {
    this.setState({ packageName: event.target.value });
  };
  handlePackageDescriptionChange = (value) => {
    this.setState({ packageDescription: value });
  };

  updatePackagePlanning = () => {
    let more_location = this.state.itineraryPlan;
    let category_id = this.state.CategoryData;
    let package_name = this.state.packageName;
    let packageDescription = this.state.packageDescription;
    let package_id = this.state.packageData?.package_data?.id;
    let packageImage = this.state.packageImage;

    if (package_name === "") {
      alert("Please enter package name");
      document.getElementById("packageNameId").focus();
      return;
    }

    if (packageDescription === "") {
      alert("Please enter package name");
      document.getElementById("exampleFormControlInput1").focus();
      return;
    }

    if (category_id === "") {
      alert("Please select package category");
      document.getElementById("mySelect").focus();
      return;
    }

    if (packageImage === "") {
      alert("Please select featured image");
      document.getElementById("fileUpload").focus();
      return;
    }

    updateAdminPackage(
      package_name,
      package_id,
      more_location,
      category_id,
      packageDescription,
      packageImage
    ).then(
      (data) => {
        this.props.clearAdminPackageCart();
        const url =
          "/adminpackagedetails?moreLocation=" +
          encodeURIComponent(JSON.stringify(this.state.addMoreLocation)) +
          "&checkin=" +
          encodeURIComponent(this.state.startDate) +
          "&checkout=" +
          encodeURIComponent(this.state.endDate) +
          "&guestCombination=" +
          JSON.stringify(this.state.cats) +
          "&itineraryPlan=" +
          encodeURIComponent(JSON.stringify(this.state.itineraryPlan)) +
          "&changeDate=" +
          encodeURIComponent(JSON.stringify(this.state.changeDate)) +
          "&package_id=" +
          encodeURIComponent(package_id);
        window.location.replace(url);
      },
      (error) => { }
    );
  };

  setBase64PackageImage = (data) => {
    this.setState({ packageImage: data });
  }

  render() {
    return (
      <>
        <div className="mainContainer" style={{ marginTop: -20 }}>
          <div
            className="title-trip-plan"
            title=""
            style={{ margin: "6px 0 6px" }}
          >
            {" "}
            Select duration for Islands / Cities
          </div>
          <p className="title-trip-para" style={{ margin: 0 }}>
            Edit your islands/cities to change your routess
          </p>
          <p className="title-trip-para" style={{ marginBottom: "10px" }}>
            Start Date{" "}
            <span className="cityStufDate">
              {moment(this.state.startDate).format("ddd, DD MMM Y")}
            </span>{" "}
            - End Date{" "}
            <span className="cityStufDate">
              {moment(this.state.endDate).format("ddd, DD MMM Y")}
            </span>
          </p>

          {this.state.itineraryPlan[0]?.children.length > 0 &&
            this.state.itineraryPlan[0]?.children.map((location, indexva) => (
              <div
                key={location?.Id}
                className="serch-top-bar"
                style={{
                  padding: "0px 5px 0px",
                  justifyContent: "center",
                  marginLeft: "20%",
                  width: "60%",
                }}
              >
                <div className="row" style={{ lineHeight: 1 }}>
                  <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 Allhover">
                    <div className="routes">
                      <div className="round">
                        <span>
                          <i
                            className="fa fa-map-marker"
                            aria-hidden="true"
                            style={{ color: "#ff924b" }}
                          ></i>{" "}
                          {location?.Location?.label}
                        </span>
                        <div
                          className="dropdown-toggle"
                          data-toggle="dropdown"
                          style={{ float: "right" }}
                        >
                          <p
                            style={{
                              fontSize: "20px !important",
                              color: "#eea027 !important",
                              marginTop: "13px !important",
                              position: "relative",
                            }}
                          >
                            {this.state.changeDate[indexva].number} Night
                          </p>
                        </div>
                        <div className="checkboxs">
                          <p
                            style={{
                              fontSize: "14px",
                              margin: "10px 5px 5px 12px",
                              padding: "5px 5px 7px",
                              textAlign: "left",
                            }}
                          >
                            {moment(
                              this.state.changeDate[indexva].startDate
                            ).format("ddd, DD MMM Y")}{" "}
                            -{" "}
                            {moment(
                              this.state.changeDate[indexva].endDate
                            ).format("ddd, DD MMM Y")}
                          </p>
                        </div>
                        <div className="dropdown-menus">
                          <div className="Most Popular">
                            <div className="form-row">
                              <div className="form-group col-md-12">
                                <div
                                  className="bor"
                                  style={{
                                    marginBottom: "10px",
                                    height: "45px",
                                  }}
                                >
                                  <RangeDatePicker
                                    startDate={
                                      this.state.changeDate[indexva].startDate
                                    }
                                    endDate={
                                      this.state.changeDate[indexva].endDate
                                    }
                                    onChange={(startDate, endDate) =>
                                      this.handleDateChange(
                                        startDate,
                                        endDate,
                                        indexva
                                      )
                                    }
                                    minDate={new Date(this.state.startDate)}
                                    maxDate={new Date(this.state.endDate)}
                                    startDatePlaceholder="Check In"
                                    endDatePlaceholder="Check Out"
                                    className="my-own-class-name"
                                    startWeekDay="monday"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}

          <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 mt-1 Allhover">
            <div
              className="routes"
              style={{
                padding: "10px",
                justifyContent: "center",
                marginLeft: "20%",
                width: "60%",
              }}
            >
              <label for="mySelect" class="form-label">
                Package Category *
              </label>
              <select
                id="mySelect"
                value={this.state.CategoryData}
                onChange={this.handleSelectCategory}
                disabled={this.state.disableSelectOption}
              >
                <option key="blank" value="" >Select</option>
                {this.state.packaeCategory.map((option, index) => (
                  <option key={index} value={option.id}>
                    {option.package_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 mt-1 Allhover">
            <div
              className="routes"
              style={{
                marginBottom: "10px",
                padding: "10px",
                justifyContent: "center",
                marginLeft: "20%",
                width: "60%",
              }}
            >
              <label for="packageNameId" class="form-label">
                Package Name *
              </label>
              <input
                type="text"
                class="form-control"
                onChange={this.handlePackageChange}
                value={this.state.packageName}
                id="packageNameId"
                placeholder="Mahe Island, Praslin Island"
              />
            </div>
          </div>
          <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 mt-1 Allhover">
            <div
              className="routes"
              style={{
                marginBottom: "10px",
                padding: "10px",
                justifyContent: "center",
                marginLeft: "20%",
                width: "60%",
              }}
            >
              <label for="exampleFormControlInput1" class="form-label">
                Package Description *
              </label>
              <ReactQuill theme="snow" value={this.state.packageDescription} onChange={this.handlePackageDescriptionChange} />
            </div>
          </div>
          <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 mt-1 Allhover">
            <div
              className="routes"
              style={{
                marginBottom: "10px",
                padding: "10px",
                justifyContent: "center",
                marginLeft: "20%",
                width: "60%",
              }}
            >
              <label for="fileUpload" class="form-label">
                Featured Image * (320*180px | 16:9 Aspect Ratio)
              </label>
              <input
                type="file"
                class="form-control"
                name="package_image"
                onChange={(e) => {
                  const file = e.target.files[0]; // Get the selected file
                  if (file) {
                    const reader = new FileReader();
                    reader.readAsDataURL(file); // Convert to Base64
                    reader.onload = () => {
                      this.setBase64PackageImage(reader.result); // Store Base64 string
                    };
                    reader.onerror = (error) => {
                      console.error("Error converting file: ", error);
                    };
                  }
                }}
                id="fileUpload"
              />
              {this.state.packageImage && <img src={this.state.packageImage} width={100} height={100} className="mt-1" />}
            </div>
          </div>
          <div className="sercheng" style={{ marginTop: 5 }}>
            <a
              onClick={this.updatePackagePlanning}
              className="btn_searchs"
              style={{ marginBottom: 30 }}
              disabled={this.state.disableSelectButton}
            >
              Update Package
            </a>
          </div>


          <div className="left-sidebar">
            <a
              href={
                "/makepackagebuild?moreLocation=" +
                encodeURIComponent(this.state.addMoreLocation) +
                "&checkin=" +
                encodeURIComponent(this.state.startDate) +
                "&checkout=" +
                encodeURIComponent(this.state.endDate) +
                "&guestCombination=" +
                JSON.stringify(this.state.cats) +
                "&itineraryPlan=" +
                encodeURIComponent(JSON.stringify(this.state.itineraryPlan)) +
                "&changeDate=" +
                encodeURIComponent(JSON.stringify(this.state.changeDate)) +
                "&package_id=" +
                encodeURIComponent(this.state.packageid) +
                "&package_open_date=" +
                encodeURIComponent(this.state.packageOpenDate) +
                "&package_close_date=" +
                encodeURIComponent(this.state.packageCloseDate)
              }
            >
              <h4>
                <i className="fa fa-arrow-left" aria-hidden="true"></i> Back
              </h4>
              {/* <p>Make Package</p> */}
            </a>
          </div>
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  clearAdminPackageCart: () => dispatch(clearAdminPackageCart()),
  planShuffleUpdateUrl: (url) => dispatch(setPlanShuffleUpdateUrl(url))
});

export default connect(null, mapDispatchToProps)(CityStuffleBanner);
